import MyClientVisitsView from "../../features/clientVisits/MyClientVisitsView";

const MyClientVisitsPage = () => <MyClientVisitsView />;

export default MyClientVisitsPage;
